import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import styled from "styled-components";

const StyledAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    padding: 0px;
    margin: 0;
    border-radius: 12px;
    border: 2px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    background-color: #fff;
  }
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  &:before {
    background-color: transparent;
  }
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const StyledSmallAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    padding: 0px;
    margin: 0;
    min-height: 30px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }
  &:not(:first-child) {
    margin-top: 10px;
  }
  &:before {
    background-color: transparent;
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    flex-direction: column;
    margin: 0;
    padding: 15px;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 8px 24px;
    margin: 0;
    border-radius: 12px;
  }
  &:hover {
    background-color: #f5f5f5;
  }
`;

export {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledSmallAccordion,
};
